// Configurazione centrale del sito: modifica qui link, contatti e ID senza toccare i componenti.
export const SITE = {
  name: "MATTIA COSIMO SARACINO",
  shortName: "Mattia Cosimo Saracino",
  role: "Consulente Aziendale",
  tagline: "Consulenza aziendale | Persone | Strategia | Organizzazione | Crescita",
  url: process.env.REACT_APP_BACKEND_URL || window.location.origin,
  // Business Freedom 360 — applicazione esterna ufficiale, già esistente (non ricreare)
  bf360: "https://ili-app-two.vercel.app/",
  email: "saracinomat98@gmail.com",
  whatsapp: "393285931144",
  whatsappLabel: "+39 328 593 1144",
  socials: {
    instagram: "https://www.instagram.com/mattiacosimo.saracino_official",
    linkedin: "https://www.linkedin.com/in/mattia-cosimo-saracino-706105159",
  },
  // Link Amazon di BEAUTY TASK
  amazonBeautyTask: "https://www.amazon.it/BEAUTY-TASK-imprenditori-imprenditrici-dalloperatività/dp/B0HG9JBCMY/ref=tmm_pap_swatch_0",
  // ID analytics da inserire quando disponibili (lasciare vuoti per disattivare)
  analytics: {
    gaId: "",
    metaPixelId: "",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Consulenza", to: "/#consulenza" },
  { label: "Metodo", to: "/#metodo" },
  { label: "Marketing", to: "/#marketing" },
  { label: "Eventi", to: "/eventi" },
  { label: "Progetti", to: "/progetti" },
  { label: "Chi sono", to: "/chi-sono" },
  { label: "Contatti", to: "/contatti" },
];
